import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export const BreadCrumbs = ({ pageName, basePath }: { pageName: string; basePath: string }) => {
  return (
    <nav className='flex items-center gap-1 text-sm sm:gap-1.5'>
      <Link
        to={`${basePath}/dashboard`}
        className='flex items-center rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600'
      >
        <Home className='h-4 w-4' />
      </Link>
      <ChevronRight className='h-3.5 w-3.5 text-gray-300' />
      <span className='font-medium text-gray-900'>{pageName}</span>
    </nav>
  );
};
